// extracted by mini-css-extract-plugin
export default {"PantallaCarga":"PantallaCarga_PantallaCarga__BgLs5"};